'use client';

import { useRef } from 'react';
import { usePageTransition } from '../use-page-transition';
import { AnimatedShipIndicator } from '../../AnimatedShipIndicator/AnimatedShipIndicator';
export const FullScreenIndicator = () => {
  const loadingScreenRef = useRef<HTMLDivElement>(null);
  usePageTransition(status => {
    const loadingScreen = loadingScreenRef.current;
    if (!loadingScreen) {
      return;
    }
    loadingScreen.style.display = status === 'ready' ? 'none' : 'flex';
  });
  return <>
      <div ref={loadingScreenRef} className="fixed inset-0 z-[9999] flex items-center justify-center bg-white">
        <AnimatedShipIndicator on="white" data-sentry-element="AnimatedShipIndicator" data-sentry-source-file="full-screen-indicator.tsx" />
      </div>
    </>;
};